import { useEffect } from 'react';
import { useReactMutation } from '../services/queryService';
import { services } from '../services/services';
import { currentPushSubscription } from './pushSubscription';

/**
 * Tells the server, once per page load, that this browser's push subscription belongs to
 * whoever is signed in now.
 *
 * A subscription is the browser's and outlives a session. Somebody whose session lapsed and
 * who signed in again -- or a second person signing in on a shared computer -- would otherwise
 * leave the server sending the device news about the previous account. The server hands an
 * address it already knows to the caller, so repeating this is harmless and is the whole fix.
 *
 * Does nothing in a browser that holds no subscription, which is nearly all of them: it never
 * registers a worker and never asks for permission. A refusal is ignored -- push being
 * switched off on the server is not something to tell anybody about on every page.
 */
export const usePushSync = (): void => {
    const { mutate } = useReactMutation(services.push.subscribeMutation());

    useEffect(() => {
        void currentPushSubscription()
            .then((subscription: PushSubscription | null) => {
                if (subscription) {
                    mutate(subscription.toJSON(), { onError: () => undefined });
                }
            })
            .catch(() => undefined);
    }, [mutate]);
};
